'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../tslib.es6-13d783d6.js');
var styled = require('styled-components');
var breakPoints_index = require('../breakPoints/index.js');

var AspectRatio = styled.css(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n    background: ", ";\n    &:before {\n        content: '';\n        width: 1px;\n        margin-left: -1px;\n        float: left;\n        height: 0;\n        padding-top: ", ";\n    }\n\n    &:after {\n        /* to clear float */\n        content: '';\n        display: table;\n        clear: both;\n    }\n\n    ", "\n"], ["\n    background: ", ";\n    &:before {\n        content: '';\n        width: 1px;\n        margin-left: -1px;\n        float: left;\n        height: 0;\n        padding-top: ", ";\n    }\n\n    &:after {\n        /* to clear float */\n        content: '';\n        display: table;\n        clear: both;\n    }\n\n    ",
    "\n"])), function (_a) {
    var theme = _a.theme, backdropColor = _a.backdropColor;
    return backdropColor || theme.colors.charcoal3;
}, function (_a) {
    var ratio = _a.ratio;
    return "calc(" + ratio.mobile.height + " / " + ratio.mobile.width + " * 100%)";
}, function (_a) {
    var ratio = _a.ratio;
    return styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n        ", "\n    "], ["\n        ",
        "\n    "])), breakPoints_index.forDesktop(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n        &:before {\n            padding-top: calc(", " / ", " * 100%);\n        }\n    "], ["\n        &:before {\n            padding-top: calc(", " / ", " * 100%);\n        }\n    "])), ratio.desktop.height, ratio.desktop.width));
});
var templateObject_1, templateObject_2, templateObject_3;

exports.AspectRatio = AspectRatio;
//# sourceMappingURL=index.js.map
